<div class="row">
  <div class="col-12 col-md-12 py-0 d-flex align-items-center">

    <!-- Search Input -->
    <div class="col-3 col-md-3">
      <div class="input-group" [class]="itemsSearchStyle">
        <input
          class="form-control input-sm"
          style="height: 30px; border-radius: 6%; cursor: pointer;"
          type="text"
          placeholder="Search"
          [(ngModel)]="itemsSearch"
          (keyup)="search()"
          >
      </div>
    </div>

    <!-- Items per page selector -->
    <div>
      <select
        style="margin: 0 5px;height: 30px; background-color: white; border-color: rgb(206, 206, 206); border-radius: 10%; cursor: pointer;"
        [(ngModel)]="itemsPerPage"
        (change)="onPerPageItemChange()"
        [ngModelOptions]="{standalone: true}">
        @for (option of itemsPerPageOptions; track option) {
          <option [value]="option.value">
            {{option.name | translate}}
          </option>
        }
      </select>
    </div>

    <!-- MatPaginator -->
    <div class="p-0 m-0">
      <mat-paginator
        style="vertical-align: middle; width: max-content; cursor: pointer;"
        [length]="totalItems"
        [pageSize]="itemsPerPage"
        [pageIndex]="currentPage - 1"
        
        (page)="handlePageChange($event)">
      </mat-paginator>
    </div>

    <!-- Total Items Display -->
    <div class="col-md-1">
      <button class="btn btn-sm btn-info" type="button" [class]="totalItemsStyle"
        style="pointer-events: none; cursor: pointer;">
        <span style="font-size: 4mm;">{{totalItems}}</span>
      </button>
    </div>

  </div>
</div>